import script from "./integration-movements-table.vue?vue&type=script&setup=true&lang=js"
export * from "./integration-movements-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__